import { render } from "./CustomerHorsesModal.vue?vue&type=template&id=322dbe0d&scoped=true"
import script from "./CustomerHorsesModal.vue?vue&type=script&lang=js"
export * from "./CustomerHorsesModal.vue?vue&type=script&lang=js"

import "./CustomerHorsesModal.vue?vue&type=style&index=0&id=322dbe0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322dbe0d"]])

export default __exports__